import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  DropdownButton,
  MenuItem,
  FormGroup,
  InputGroup,
  FormControl,
  ButtonGroup,
  Modal,
  ControlLabel,
  Row,
  Col,
  Checkbox
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import {
  formSetting,
  saveBecomeForm,
} from "../../../redux/actions/siteActions";
import moment from "moment";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import { allUser } from "../../../redux/actions/subAdminActions";

const history = createBrowserHistory();

let isLoading = "false";
class OtherFormSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Form Setting"],
      links: ["home", "form-setting"],
      show: false,
      formList: '',
      alertMessage: '',
      Optin:'0'
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillMount() {
    isLoading = "true";
    this.props.formSetting('dynamic-form/list');
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.formList !== nextProps.formList){
    	if(nextProps.formList){
        isLoading = "false";
        let formList = {'registration':nextProps.formList.registration, 'subscription':nextProps.formList.subscription} 
    		this.setState({formList: formList})
        if(nextProps.formList.Optin && !isEmpty(nextProps.formList.Optin)) {
          this.setState({Optin: nextProps.formList.Optin[0].enabled});
        }
    	}
    }

    if (this.props.formStatus !== nextProps.formStatus) {
      if (nextProps.formStatus) {
        this.props.clearAlert();
        this.handleShow();
        if (nextProps.formStatus.message) {
          isLoading = "false";
          window.scrollTo(0, 0);
          this.props.renderAlert("success", nextProps.formStatus.message);
        }
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  handleEnabled = (e) => {
  	let newValue;
    let indexValue = e.target.attributes.getNamedItem("data-key").value;
    let data = e.target.attributes.getNamedItem("data-id").value;
    if(e.target.checked){
      newValue = "0";
    }else{
      newValue = "1";
    }

    let newFormList = [];
    let newArray = [];

    newFormList = Object.keys(this.state.formList).map((key, idx) => {
      newArray[key] = this.state.formList[key].map((listdata, idx) => {
        if (data == key && indexValue == listdata.name) {
          return { ...listdata, enabled: newValue };
        }else{
          return listdata;
        }
      })
      return newArray;
    });
    this.setState({formList: newFormList[0]});
  }

  handleChange = (e) => {
    this.setState({Optin: e.target.value});
  }

  handleRequired = (e) => {
  	let newValue;
  	let indexValue = e.target.attributes.getNamedItem("data-key").value;
    let data = e.target.attributes.getNamedItem("data-id").value;
  	if(e.target.checked){
  		newValue = "0";
  	}else{
  		newValue = "1";
  	}

    let newFormList = [];
    let newArray = [];

    newFormList = Object.keys(this.state.formList).map((key, idx) => {
      newArray[key] = this.state.formList[key].map((listdata, idx) => {
        if (data == key && indexValue == listdata.name) {
          return { ...listdata, required: newValue };
        }else{
          return listdata;
        }
      })
      return newArray;
    });
    this.setState({formList: newFormList[0]});
  }

  handleSubmit = (e) => {
    isLoading = "true";
  	const constData = {
  		data: [{registration: this.state.formList['registration'], subscription: this.state.formList['subscription'], Optin:this.state.Optin}],
  	}
  	this.props.saveBecomeForm(constData, 'dynamic-form/save');
  }

  render() {
    const {formList} = this.state; 
    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Form Setting</header>
            <div className="panel-body">
              <div className="clearfix" />
              <div className="row">
                {this.state.show &&
                  this.state.alertMessage !== "" && (
                    <div className="col-lg-12">
                      <Alert
                        bsStyle={this.state.msgType}
                        onDismiss={this.handleDismiss}
                      >
                        <strong>{this.state.msgType}:</strong>{" "}
                        {this.state.alertMessage}
                      </Alert>
                    </div>
                  )}
                  {(formList) &&
                    Object.keys(formList).map((data, index) =>
                      <React.Fragment>
                        <div className="col-lg-12">
                          <h4>{data[0].toUpperCase()+data.substring(1)} Form Setting:</h4>
                        </div>
                        <div className="col-lg-12">
                          <table className="table table-hover">
                            <thead>
                              <tr>
                                <th>Field</th>
                                <th>Enable</th>
                                <th>Required</th>
                              </tr>
                            </thead>
                            <tbody>
                              {formList[data] &&
                                formList[data].map((list, index) => 
                                  <tr key={index}>
                                    <td>{list.title}</td>
                                    <td><Checkbox data-id={data} data-key={list.name} onClick={this.handleEnabled} defaultChecked={list.enabled == '0' ? true : false}></Checkbox></td>
                                    <td><Checkbox data-id={data} data-key={list.name} onClick={this.handleRequired} defaultChecked={list.required == '0' ? true : false}></Checkbox></td>
                                  </tr>
                                )
                              }
                            </tbody>
                          </table>
                        </div>
                      </React.Fragment>
                    )
                  }
                  
                  <div className="col-lg-12">
                    <h4>Optin form on 3rd row offer Setting:</h4>
                  </div>
                  <div className="col-lg-4">
                    <FormGroup>
                      <FormGroup controlId="Optin">
                        <ControlLabel>Optin form on 3rd row offer Setting</ControlLabel>
                        <FormControl name="Optin" componentClass="select" value={this.state.Optin} onChange={this.handleChange} >
                          <option value="1">Enable</option>
                          <option value="0">Disable</option>
                        </FormControl>
                      </FormGroup>
                    </FormGroup>
                  </div>
                <div className="col-lg-12">
                	<Button bsStyle="primary" onClick={this.handleSubmit}>Save</Button>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div> 
      </div>
    );
  }
}

const mapStateToProps = state => ({
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  formList: state.siteReducer.formList,
  formStatus: state.siteReducer.formStatus,
  error: state.siteReducer.error,
});

export default connect(mapStateToProps, {
  renderAlert,
  clearAlert,
  formSetting,
  saveBecomeForm
})(OtherFormSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/setting/OtherFormSetting.js